<template>
    <div class="wrap login_wrap">
        <!-- 01_로그인 -->
        <!-- container -->
        <div class="container">
            <section class="section sec1">
                <div class="login_box">
                    <div class="logo_box">
                        <img :src="`${$STATIC_URL}/admin/img/logo.png`" alt="">
                    </div>
                    <div class="form_box">
                        <div class="input_box">
                            <input type="text" v-model="loginId" class="input_text" placeholder="아이디 입력">
                        </div>
                        <div class="input_box">
                            <input type="password" v-model="loginPwd" class="input_text" placeholder="비밀번호 입력">
                            <div class="check_box">
                                <input type="checkbox" id="remember_id" class="input_check">
                                <label for="remember_id" class="label_check center">
                                    아이디 기억하기
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="btn_box">
                        <button type="button" @click="login" class="btn full big">로그인</button>
                    </div>
                </div>
            </section>

        </div>

        <InfoModal v-if="$store.getters.getInfoModal" />

    </div>
</template>

<script setup>
import { ref } from 'vue';
import { adminLogin } from '@/api';
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import InfoModal from '@/components/InfoModal.vue';
// 전역 변수 가져오기

const store = useStore();
const router = useRouter();
const loginId = ref('');
const loginPwd = ref('');

const login = async () => {
    if (loginId.value.trim() === '' || loginPwd.value.trim() === '') {
        store.commit('setInfoModal', '아이디와 비밀번호를 입력해주세요.');
        return;
    } else {
        try {
            await adminLogin({
                id: loginId.value.trim(),
                pw: loginPwd.value.trim()
            });
            router.push('/admin/home');
        } catch (err) {
            if (err.status == 401) {
                store.commit('setInfoModal', '아이디와 비밀번호를 확인해주세요.');
            } else {
                store.commit('setInfoModal', '서버 오류입니다.');
            }
        }
    }
}

</script>

<style scoped>
/* 나타날 때 */
.fade-enter-from {
    opacity: 1;
    /* 나타날 때 바로 보이도록 설정 */
    transform: translateY(0px);
    /* 애니메이션 없이 바로 위치 설정 */
}

.fade-enter-active {
    transition: none;
    /* 나타날 때 애니메이션 제거 */
}

.fade-enter-to {
    opacity: 1;
    transform: translateY(0px);
}

/* 사라질 때 */
.fade-leave-from {
    opacity: 1;
    /* 초기 상태 */
}

.fade-leave-active {
    transition: opacity 0.5s;
    /* 사라질 때만 서서히 처리 */
}

.fade-leave-to {
    opacity: 0;
    /* 서서히 사라짐 */
}

/* 추가 클래스 (선택사항) */
.start {
    opacity: 0;
    transition: none;
    /* 시작 시 바로 나타나도록 설정 */
}

.end {
    opacity: 1;
}
</style>